import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_09aafdb1 from 'nuxt_plugin_plugin_09aafdb1' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_pluginclient_176dac6b from 'nuxt_plugin_pluginclient_176dac6b' // Source: ./dotdigital/plugin.client.js (mode: 'client')
import nuxt_plugin_cookiebotutils_4c51803f from 'nuxt_plugin_cookiebotutils_4c51803f' // Source: ./cookie-consent/runtime/cookiebot-utils.js (mode: 'all')
import nuxt_plugin_pluginclient_8bda1800 from 'nuxt_plugin_pluginclient_8bda1800' // Source: ./cookie-consent/runtime/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginclient_86f08cdc from 'nuxt_plugin_pluginclient_86f08cdc' // Source: ./search/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginproductssearch_2c5ec4c0 from 'nuxt_plugin_pluginproductssearch_2c5ec4c0' // Source: ./search/plugin.products-search.js (mode: 'all')
import nuxt_plugin_pluginsearch_cff9c2d6 from 'nuxt_plugin_pluginsearch_cff9c2d6' // Source: ./search/plugin.search.js (mode: 'all')
import nuxt_plugin_plugin_11400b20 from 'nuxt_plugin_plugin_11400b20' // Source: ./wishlist/plugin.js (mode: 'all')
import nuxt_plugin_plugin_0c3d52ef from 'nuxt_plugin_plugin_0c3d52ef' // Source: ./gtm/plugin.js (mode: 'all')
import nuxt_plugin_pluginprismiclinkclient_58a324ab from 'nuxt_plugin_pluginprismiclinkclient_58a324ab' // Source: ./prismic/plugin.prismic-link.client.js (mode: 'client')
import nuxt_plugin_plugingql_1ca1bf56 from 'nuxt_plugin_plugingql_1ca1bf56' // Source: ./prismic/plugin.gql.js (mode: 'all')
import nuxt_plugin_prismic_21808176 from 'nuxt_plugin_prismic_21808176' // Source: ./prismic/plugins/prismic.js (mode: 'all')
import nuxt_plugin_prismiccomponents_4d7c0606 from 'nuxt_plugin_prismiccomponents_4d7c0606' // Source: ./prismic/plugins/prismic-components.js (mode: 'all')
import nuxt_plugin_bugsnag_0204cca8 from 'nuxt_plugin_bugsnag_0204cca8' // Source: ./bugsnag.js (mode: 'all')
import nuxt_plugin_image_3cb3317c from 'nuxt_plugin_image_3cb3317c' // Source: ./image.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_02a19bef from 'nuxt_plugin_cookieuniversalnuxt_02a19bef' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_12c12b72 from 'nuxt_plugin_axios_12c12b72' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_apollomodule_78d2ff13 from 'nuxt_plugin_apollomodule_78d2ff13' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_webfontloader_3c5d0d72 from 'nuxt_plugin_webfontloader_3c5d0d72' // Source: ./webfontloader.js (mode: 'client')
import nuxt_plugin_deviceplugin_7127cad2 from 'nuxt_plugin_deviceplugin_7127cad2' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_globalfilters_775d0cc7 from 'nuxt_plugin_globalfilters_775d0cc7' // Source: ../plugins/global-filters (mode: 'all')
import nuxt_plugin_globaldirectives_418f5490 from 'nuxt_plugin_globaldirectives_418f5490' // Source: ../plugins/global-directives (mode: 'all')
import nuxt_plugin_globalmixin_0c4c8f66 from 'nuxt_plugin_globalmixin_0c4c8f66' // Source: ../plugins/global-mixin (mode: 'all')
import nuxt_plugin_axiosapi_74e18ce6 from 'nuxt_plugin_axiosapi_74e18ce6' // Source: ../plugins/axios-api (mode: 'all')
import nuxt_plugin_cart_6a7eeb96 from 'nuxt_plugin_cart_6a7eeb96' // Source: ../plugins/cart (mode: 'all')
import nuxt_plugin_vueobservevisibility_9bd06b0e from 'nuxt_plugin_vueobservevisibility_9bd06b0e' // Source: ../plugins/vue-observe-visibility.client (mode: 'client')
import nuxt_plugin_liteytembed_4640b16e from 'nuxt_plugin_liteytembed_4640b16e' // Source: ../plugins/lite-yt-embed.client (mode: 'client')
import nuxt_plugin_litevimeoembed_3e8f369c from 'nuxt_plugin_litevimeoembed_3e8f369c' // Source: ../plugins/lite-vimeo-embed.client (mode: 'client')
import nuxt_plugin_shopifyvue_051a3a49 from 'nuxt_plugin_shopifyvue_051a3a49' // Source: ../plugins/shopify-vue (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Snooze Blog | Tips, Advice & Inspiration | Snooze","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""}],"link":[{"rel":"preconnect","href":"\u002F\u002Ffonts.gstatic.com","crossorigin":true},{"rel":"preconnect","href":"\u002F\u002Fimages.prismic.io","crossorigin":true}],"script":[{"src":"https:\u002F\u002Fcdn.optimizely.com\u002Fjs\u002F22055690488.js","defer":true,"type":"text\u002Fplain","data-cookieconsent":"analytics"},{"hid":"gtag-script-id","innerHTML":"  window.dataLayer = window.dataLayer || [];\n  function gtag(){dataLayer.push(arguments);}\n"},{"hid":"gtm-script-id","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');;\n(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','GTM-W2KMCB5');;}","type":"text\u002Fplain","data-cookieconsent":"marketing,statistics"},{"hid":"__dot-digital__tracking-script","innerHTML":"(function (w, d, u, t, o, c) {\n  w[\"dmtrackingobjectname\"] = o;\n  c = d.createElement(t);\n  c.async = 1;\n  c.src = u;\n  t = d.getElementsByTagName(t)[0];\n  t.parentNode.insertBefore(c, t);\n  w[o] =\n    w[o] ||\n    function () {\n      (w[o].q = w[o].q || []).push(arguments);\n    };\n})(window, document, \"\u002F\u002Fstatic.trackedweb.net\u002Fjs\u002F_dmptv4.js\", \"script\", \"dmPt\");\nwindow.dmPt(\n  \"create\",\n  \"DM-2940786049-03\",\n  \"snooze-au.myshopify.com,checkout.snooze.com.au,snooze.com.au,www.snooze.com.au\"\n);","type":"text\u002Fplain","data-cookieconsent":"statistics"}],"style":[],"__dangerouslyDisableSanitizersByTagID":{"gtm-script-id":["innerHTML"],"gtag-script-id":["innerHTML"],"__dot-digital__tracking-script":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_09aafdb1 === 'function') {
    await nuxt_plugin_plugin_09aafdb1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_176dac6b === 'function') {
    await nuxt_plugin_pluginclient_176dac6b(app.context, inject)
  }

  if (typeof nuxt_plugin_cookiebotutils_4c51803f === 'function') {
    await nuxt_plugin_cookiebotutils_4c51803f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_8bda1800 === 'function') {
    await nuxt_plugin_pluginclient_8bda1800(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_86f08cdc === 'function') {
    await nuxt_plugin_pluginclient_86f08cdc(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginproductssearch_2c5ec4c0 === 'function') {
    await nuxt_plugin_pluginproductssearch_2c5ec4c0(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsearch_cff9c2d6 === 'function') {
    await nuxt_plugin_pluginsearch_cff9c2d6(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_11400b20 === 'function') {
    await nuxt_plugin_plugin_11400b20(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_0c3d52ef === 'function') {
    await nuxt_plugin_plugin_0c3d52ef(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginprismiclinkclient_58a324ab === 'function') {
    await nuxt_plugin_pluginprismiclinkclient_58a324ab(app.context, inject)
  }

  if (typeof nuxt_plugin_plugingql_1ca1bf56 === 'function') {
    await nuxt_plugin_plugingql_1ca1bf56(app.context, inject)
  }

  if (typeof nuxt_plugin_prismic_21808176 === 'function') {
    await nuxt_plugin_prismic_21808176(app.context, inject)
  }

  if (typeof nuxt_plugin_prismiccomponents_4d7c0606 === 'function') {
    await nuxt_plugin_prismiccomponents_4d7c0606(app.context, inject)
  }

  if (typeof nuxt_plugin_bugsnag_0204cca8 === 'function') {
    await nuxt_plugin_bugsnag_0204cca8(app.context, inject)
  }

  if (typeof nuxt_plugin_image_3cb3317c === 'function') {
    await nuxt_plugin_image_3cb3317c(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_02a19bef === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_02a19bef(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_12c12b72 === 'function') {
    await nuxt_plugin_axios_12c12b72(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_78d2ff13 === 'function') {
    await nuxt_plugin_apollomodule_78d2ff13(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_webfontloader_3c5d0d72 === 'function') {
    await nuxt_plugin_webfontloader_3c5d0d72(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_7127cad2 === 'function') {
    await nuxt_plugin_deviceplugin_7127cad2(app.context, inject)
  }

  if (typeof nuxt_plugin_globalfilters_775d0cc7 === 'function') {
    await nuxt_plugin_globalfilters_775d0cc7(app.context, inject)
  }

  if (typeof nuxt_plugin_globaldirectives_418f5490 === 'function') {
    await nuxt_plugin_globaldirectives_418f5490(app.context, inject)
  }

  if (typeof nuxt_plugin_globalmixin_0c4c8f66 === 'function') {
    await nuxt_plugin_globalmixin_0c4c8f66(app.context, inject)
  }

  if (typeof nuxt_plugin_axiosapi_74e18ce6 === 'function') {
    await nuxt_plugin_axiosapi_74e18ce6(app.context, inject)
  }

  if (typeof nuxt_plugin_cart_6a7eeb96 === 'function') {
    await nuxt_plugin_cart_6a7eeb96(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueobservevisibility_9bd06b0e === 'function') {
    await nuxt_plugin_vueobservevisibility_9bd06b0e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_liteytembed_4640b16e === 'function') {
    await nuxt_plugin_liteytembed_4640b16e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_litevimeoembed_3e8f369c === 'function') {
    await nuxt_plugin_litevimeoembed_3e8f369c(app.context, inject)
  }

  if (typeof nuxt_plugin_shopifyvue_051a3a49 === 'function') {
    await nuxt_plugin_shopifyvue_051a3a49(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
